<div class="d-block">
    <router-outlet></router-outlet>
</div>